export default __webpack_public_path__ + "static/media/gov ids.aff2f5db.png";